import React, { useState, useEffect } from "react";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import {
  Login,
  MFA,
  Logout,
  Users,
  AuditLogs,
  Patient,
  ManageUser,
  NotFound,
  Verify,
  ForgotPassword,
  ResetPassword,
  ObservationTabletChart,
  Reports,
  Home,
  Hospitals,
  Wards,
  AppHeader,
  MiniDrawer,
  // SurveyCreator,
  // FormsScreen,
  // SurveyResults,
  // SurveyRun,
} from "@pages";

import { Typography } from "@mui/material";

import moment from "moment";

const adminReqRoles = [1, 2, 3];
const normalReqRoles = [5, 6, 7, 8];

export default function App() {
  const TOKEN_NAME = "covid19_token";
  const USER_LEVEL = "user_level";

  const checkAccessLevel = (target) => {
    const token = localStorage.getItem(TOKEN_NAME);
    const mfa_token = localStorage.getItem("mfa_token");

    if (token && mfa_token) {
      const userLevel = parseInt(localStorage.getItem(USER_LEVEL), 10);

      if (target.indexOf(Number(userLevel)) !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const hasWindow = typeof window !== "undefined";

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const currentYear = moment().format("YYYY");

  useEffect(() => {
    if (hasWindow) {
      window.addEventListener("resize", resize);
      return () => window.removeEventListener("resize", resize);
    }
  }, [hasWindow]);

  const resize = () => {
    if (isDrawerOpen && window.innerWidth <= 760) {
      setIsDrawerOpen(false);
      setIsMobile(window.innerWidth <= 760);
    }
    setIsMobile(window.innerWidth <= 760);
  };

  const onDrawerToggle = () => {
    if (!isMobile) {
      setIsDrawerOpen(!isDrawerOpen);
    }
  };

  return (
    <Router>
      <div
        className={{
          width: "100%",
          height: "100vh",
          zIndex: 1,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            width: "100%",
            height: "100%",
          }}
        >
          <AppHeader drawerOpen={isDrawerOpen} toggleDrawer={onDrawerToggle} />
          <MiniDrawer open={isDrawerOpen} />
          <main
            style={{
              width: "100%",
              flexGrow: 1,
              margin: "64px 0px 0px 0px",
              //padding: 5,
              //height: "calc(100% - 65px)",
              //overflowY: "auto",
            }}
          >
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/mfa" component={MFA} />
              <Route exact path="/logout" component={Logout} />
              <Route exact path="/verify" component={Verify} />
              <Route exact path="/forgot" component={ForgotPassword} />
              <Route exact path="/resetpassword" component={ResetPassword} />
              <Route
                exact
                path="/observation-tablet-chart"
                component={ObservationTabletChart}
              />
              <Route exact path="/home" component={Home} />
              <Route exact path="/hospitals" component={Hospitals} />
              <Route exact path="/wards" component={Wards} />
              <Route exact path="/users" component={Users} />
              <Route exact path="/logs" component={AuditLogs} />
              <Route exact path="/reports" component={Reports} />
              <Route exact path="/patients/:patientId" component={Patient} />
              {/* <Route exact path="/surveycreator" component={SurveyCreator} />
              <Route exact path="/formsscreen" component={FormsScreen} />
              <Route exact path="/surveyresults" component={SurveyResults} />
              <Route exact path="/surveyrun" component={SurveyRun} /> */}

              <Route exact path="/not-found" component={NotFound} />
              <Redirect from="*" to="/not-found" />
            </Switch>

            <Typography
              variant="body1"
              style={{ paddingTop: 16, textAlign: "center" }}
            >
              Connects Health &copy; {currentYear}
            </Typography>
          </main>
        </div>
      </div>
    </Router>
  );
}
